<script>

</script>

<div class='notice'>
    <div class="title">* 주의사항</div>
    
    <ol>
        <li>'<p>테스트</p>' 게시글의 경우, 작성이로부터 <p>30일 이후</p>에 삭제될 수 있습니다.</li>
        <li>무성의하게 작성된 '<p>제목</p>', '<p>닉네임</p>'의 경우, 임의로 삭제 또는 수정될 수 있습니다.</li>
        <li>버그 및 오타 발견시, 연락 부탁드립니다 => (<a href="https://open.kakao.com/me/admin_turtle" rel="noopener noreferrer" target="_blank">연락</a>)</li>
    </ol>
</div>

<style lang="scss">
    .notice {
        width: calc(100% - 20px - 2px);
        height: fit-content;
        margin-top: 20px;
        padding: 10px;
        border: 1px solid $cl3;
        font-size: 16px;

        .title {
            font-size: 20px;
            font-family: aggro;
        }

        ol {
            width: calc(100% - 25px);
            margin: 0;
            padding: 0;
            margin-left: 25px;

            li {
                margin: 5px 0;
                p {
                    width: fit-content;
                    margin: 0;
                    padding: 0;
                    color: $cl4;
                    font-weight: bold;
                    display: inline-block;
                }
            }
        }
    }
</style>